/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import SubCustomerRoutes from './subcustomer.routes';
import SubCustomerDirective from './subcustomer.directive';
import SubCustomerTableConfig from './subcustomer-table.config';
import SubCustomerDetailsController from './subcustomer-details.controller';

export default angular.module('tektelic.subCustomer', [])
    .config(SubCustomerRoutes)
    .controller('SubCustomerDetailsController', SubCustomerDetailsController)
    .directive('tkSubCustomer', SubCustomerDirective)
    .factory('subCustomerTableConfig', SubCustomerTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/subcustomer/index.js